/**
 * Scope chooser for DELETING a recurring event.
 *
 * The detail dialog offers ONE delete affordance, and a series asks which
 * occurrences it applies to. An earlier UI put three destructive buttons
 * ("Delete This" / "This & Future" / "All Events") permanently in the footer of
 * every event — three red buttons is not three times the affordance, it is a
 * wall the user has to read before doing the common thing, and it made a single
 * (non-recurring) event look equally dangerous.
 *
 * The options, ordering, default and keyboard behaviour live in
 * `RecurringScopeDialog`, shared with the edit flow so the two cannot drift.
 */

import { RecurringScopeDialog } from './RecurringScopeDialog';
import type { RecurrenceEditScope } from '../types';

interface DeleteRecurringEventDialogProps {
  open: boolean;
  /** Event title, shown so the user can confirm what they are about to remove. */
  title: string;
  onCancel: () => void;
  onConfirm: (scope: RecurrenceEditScope) => void;
}

export function DeleteRecurringEventDialog({
  open,
  title,
  onCancel,
  onConfirm,
}: DeleteRecurringEventDialogProps) {
  return (
    <RecurringScopeDialog
      open={open}
      heading="Delete recurring event"
      title={title}
      legend="Which events should be deleted?"
      name="delete-scope"
      confirmLabel="Delete"
      destructive
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  );
}
